module.exports = __webpack_public_path__ + "static/media/profile-10.0e25c722.png";